import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AuthDispatchersService } from './auth-dispatchers.service';
import { AuthEffects } from './auth.effects';
import { authReducer } from './auth.reducer';
import { AuthSelectorsService } from './auth-selectors.service';

/**
 * Provide auth store using factory function instead of module
 */
export function provideAuthStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState('auth', authReducer),
    provideEffects(AuthEffects),
    AuthDispatchersService,
    AuthSelectorsService
  ]);
}
